<template>
  <div class="box5">
    <pageTitle
      title="2026 AI大模型开发课程<br/>全新升级"
      text="调研2000+学员，对标500+企业需求<br/>打造一站式AI行业就业解决方案"
      titleColor="#24375c"
      titColor="#86909C"
    />

    <div class="feature-card">
      <ul class="feature-list">
        <li v-for="(item, index) in featureList" :key="index">
          <i class="feature-list__dot"></i>
          <span class="feature-list__prefix">{{ item.prefix }}</span>
          <span class="feature-list__highlight">{{ item.highlight }}</span>
        </li>
      </ul>
      <img
        class="feature-card__badge"
        src="../../../assets/coursePage/llm/box5/badge-new.png"
        alt=""
      />
    </div>

    <div class="stats-grid">
      <div
        class="stats-item"
        v-for="(item, index) in statsList"
        :key="index"
      >
        <div class="stats-item__num">
          <template v-if="item.prefix">
            <span class="stats-item__small">{{ item.prefix }}</span>
          </template>
          <span class="stats-item__value">{{ item.value }}</span>
          <span v-if="item.suffix" class="stats-item__small">{{
            item.suffix
          }}</span>
        </div>
        <p class="stats-item__label">{{ item.label }}</p>
      </div>
    </div>

    <p class="footnote">
      *数据来源：黑马程序员AI大模型学科2025年1月至2026年5月<br/>线上学员就业数据分析
    </p>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import ConsultBtn from "./ConsultBtn.vue";

export default {
  components: {
    pageTitle,
    ConsultBtn,
  },
  data() {
    return {
      featureList: [
        { prefix: "阶梯式学习，", highlight: "零基础从入门到上岗" },
        { prefix: "应用为王，", highlight: "10+企业级项目实战" },
        { prefix: "对标企业需求，", highlight: "覆盖四大热门AI技术" },
        { prefix: "深耕底层原理，", highlight: "强化AI算法深度" },
        { prefix: "大厂联合研发，", highlight: "学的就是行业标准" },
        { prefix: "智能开发范式，", highlight: "抢占行业新赛道" },
      ],
      statsList: [
        {
          prefix: "约",
          value: "65",
          suffix: "%学员",
          label: "来自零基础或转行人员",
        },
        {
          prefix: "约",
          value: "400",
          suffix: "%",
          label: "最高薪资涨幅达",
        },
        {
          value: "16667",
          suffix: "元",
          label: "2026年平均就业薪资",
        },
        {
          value: "30000",
          suffix: "元",
          label: "2026年最高薪资",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
@import './variables.less';

.box5 {
  position: relative;
  padding: 80px 32px;
  width: 100%;
  box-sizing: border-box;
  background: url("../../../assets/coursePage/llm/box5/bg.png") no-repeat top
    center;
  background-size: 100% 100%;
  background-color: #f3f6ff;

  /deep/ .course-title-box {
    position: relative;
    z-index: 1;
  }

  /deep/ .course-title {
    font-size: 48px;
    line-height: 68px;
    font-weight: 500;
  }

  /deep/ .course-text {
    font-size: 26px;
    line-height: 44px;
    margin-top: 14px;
  }

  .feature-card {
    position: relative;
    z-index: 1;
    margin-top: 48px;
   
    padding: 32px 44px;
    box-sizing: border-box;
    background: url("../../../assets/coursePage/llm/box5/feature-card-bg.png")
      no-repeat center;
    background-size: 100% 100%;

    &__badge {
      position: absolute;
      right: 16px;
      top: 50%;
      transform: translateY(-50%);
      width: 168px;
      height: 168px;
      pointer-events: none;
    }
  }

  .feature-list {
    position: relative;
    z-index: 1;
    max-width: 480px;

    li {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 4px;
      line-height: 52px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__dot {
      flex-shrink: 0;
      width: 10px;
      height: 10px;
      margin-right: 16px;
      border-radius: 50%;
      background: #072557;
    }

    &__prefix {
      font-family: PingFangSC, PingFang SC;
      font-size: 28px;
      font-weight: 400;
      color: #072557;
    }

    &__highlight {
      font-family: PingFangSC, PingFang SC;
      font-size: 28px;
      font-weight: 500;
      .llm-text-gradient();
    }
  }

  .stats-grid {
    position: relative;
    z-index: 1;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 8px;
  }

  .stats-item {
    width: calc((100% - 24px) / 2);
    min-height: 164px;
    margin-bottom: 0px;
    padding: 24px 16px;
    box-sizing: border-box;
    text-align: center;
   

    &:nth-last-child(-n + 2) {
      margin-bottom: 0;
    }

    &__num {
      display: flex;
      align-items: baseline;
      justify-content: center;
      min-height: 60px;
      .llm-text-gradient();
    }

    &__small {
      font-family: PingFangSC, PingFang SC;
      font-size: 36px;
      font-weight: 400;
      line-height: 60px;
     
    }

    &__value {
      font-family: PingFangSC, PingFang SC;
      font-size: 60px;
      font-weight: 400;
      line-height: 60px;
     
    }

    &__label {
      margin-top: 8px;
      font-family: PingFangSC, PingFang SC;
      font-size: 26px;
      font-weight: 400;
      color: #0f2654;
      line-height: 40px;
    }
  }

  .footnote {
    position: relative;
    z-index: 1;
   
    font-family: PingFangSC, PingFang SC;
    font-size: 22px;
    font-weight: 400;
    color: #9b9c9f;
    line-height: 32px;
    text-align: center;
  }

}
</style>
